import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M15.82 15.518c-.751 1.176-1.993 1.856-3.234 1.856-1.9 0-3.51-1.53-3.97-3.598h3.924v-.709H8.493c-.03-.283-.03-.623-.03-.893h4.046v-.708H8.555c.413-2.154 2.053-3.769 4-3.769 1.272 0 2.452.68 3.234 1.856l.2.298.658-.368-.199-.298c-.92-1.374-2.36-2.21-3.878-2.21-2.314 0-4.337 1.898-4.782 4.477H6.47v.708h1.242c0 .27-.016.61.015.893H6.485v.708h1.35c.474 2.338 2.36 4.322 4.766 4.322 1.517 0 2.958-.836 3.878-2.21l.199-.298-.659-.368Z" }, null, -1),
    _createElementVNode("path", { d: "M20.565 12.529a8.056 8.056 0 1 0-16.112 0 8.056 8.056 0 0 0 16.112 0m.584 0a8.64 8.64 0 1 1-17.28 0 8.64 8.64 0 0 1 17.28 0" }, null, -1)
  ]))]))
}
export default { render: render }